import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DELETE, GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

export const postCart = createAsyncThunk(
  "post-cart",
  async ({ data, isSignIn }, { rejectWithValue }) => {
    try {
      if (isSignIn) {
        const response = await POST(API.CART, data);
        return response;
      } else {

        console.log(data?.quantity,'data?.quantity data?.quantity');
        
        const item = {
          id: Date.now(), // unique id for each item
          quantity: data?.quantity || 1,
          product_id: data?.product_id,
          variant_id: data?.variant_id,
          selectedAddOns: data?.selectedAddOns || [],
          Product: {
            name: data?.product_name,
            image: data?.image,
            tax_percentage: data?.tax_percentage,
          },
          Product_Variant: {
            name: data?.variant_name,
            mrp: data?.mrp,
            price: data?.price,
            description: data?.description,
          },
        };

        const existingCart = Cookies.get("Chefcut_Cart");
        let updatedCart = existingCart ? JSON.parse(existingCart) : [];

        // Always push new item (no merging)
        updatedCart.push(item);

        Cookies.set("Chefcut_Cart", JSON.stringify(updatedCart), {
          expires: 7,
        });

        return { success: true, data: updatedCart };
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postCartQuantity = createAsyncThunk(
  "post-cart-quantity",
  async ({ data }, { rejectWithValue }) => {
    try {
      if (data?.isSignIn) {
        const response = await POST(API.CART_QUANTITY, data);
        return response;
      } else {
        const cartFromCookies = Cookies.get("Chefcut_Cart");
        if (!cartFromCookies) {
          return {
            data: { success: false, message: "Cart is empty", data: [] },
          };
        }

        const cartData = JSON.parse(cartFromCookies);

        const foundItemIndex = cartData.findIndex(
          (item) => Number(item.id) === Number(data?.cart_id)
        );

        if (foundItemIndex === -1) {
          return {
            data: { success: false, message: "Item not found", data: [] },
          };
        }

        // Update quantity or remove
        if (data?.type === "add") {
          cartData[foundItemIndex].quantity += 1;
        } else if (data?.type === "minus") {
          if (cartData[foundItemIndex].quantity > 1) {
            cartData[foundItemIndex].quantity -= 1;
          } else {
            cartData.splice(foundItemIndex, 1);
          }
        }

        // Save updated cart
        Cookies.set("Chefcut_Cart", JSON.stringify(cartData), {
          expires: 7,
        });

        return { data: { success: true, data: cartData } };
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const postCart = createAsyncThunk(
//   "post-cart",
//   async ({ data, isSignIn }, { rejectWithValue }) => {
//     try {
//       if (isSignIn) {
//         const response = await POST(API.CART, data);
//         return response;
//       } else {
//         // Build guest cart item
//         const item = {
//           quantity: 1,
//           product_id: data?.product_id,
//           variant_id: data?.variant_id,
//           selectedAddOns: data?.selectedAddOns || [],
//           Product: {
//             name: data?.product_name,
//             image: data?.image,
//             tax_percentage: data?.tax_percentage,
//           },
//           Product_Variant: {
//             name: data?.variant_name,
//             mrp: data?.mrp,
//             price: data?.price,
//             description: data?.description,
//           },
//         };

//         const existingCart = Cookies.get("Chefcut_Cart");
//         let updatedCart = existingCart ? JSON.parse(existingCart) : [];

  

//         const existingItemIndex = updatedCart.findIndex(
//           (cartItem) =>
//             cartItem.product_id === item.product_id &&
//             cartItem.variant_id === item.variant_id &&
//             JSON.stringify(cartItem.selectedAddOns) === JSON.stringify(item.selectedAddOns) // consider add-ons in uniqueness
//         );

//         if (existingItemIndex > -1) {
//           updatedCart[existingItemIndex].quantity += item.quantity;
//         } else {
//           updatedCart.push(item);
//         }

//         Cookies.set("Chefcut_Cart", JSON.stringify(updatedCart));
//         return { success: true, data: updatedCart };
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );



// export const postCartQuantity = createAsyncThunk(
//   "post-cart-quantity",
//   async ({ data }, { rejectWithValue }) => {
//     try {
//       if (data?.isSignIn) {
//         const response = await POST(API.CART_QUANTITY, data);
//         return response;
//       } else {
//         const cartFromCookies = Cookies.get("Chefcut_Cart");
//         if (!cartFromCookies) {
//           return { data: { success: false, message: "Cart is empty", data: [] } };
//         }

//         const cartData = JSON.parse(cartFromCookies);

//         // Find the item by unique ID
//         const foundItemIndex = cartData.findIndex(
//           (item) => item.id === data?.id
//         );

//         if (foundItemIndex === -1) {
//           return { data: { success: false, message: "Item not found", data: [] } };
//         }

//         // Update quantity or remove
//         if (data?.type === "add") {
//           cartData[foundItemIndex].quantity += 1;
//         } else if (data?.type === "minus") {
//           if (cartData[foundItemIndex].quantity > 1) {
//             cartData[foundItemIndex].quantity -= 1;
//           } else {
//             cartData.splice(foundItemIndex, 1);
//           }
//         }

//         // Save updated cart
//         Cookies.set("Chefcut_Cart", JSON.stringify(cartData), {
//           expires: 7,
//         });

//         return { data: { success: true, data: cartData } };
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
export const addToCard = createAsyncThunk(
  "auth/add-to-card",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(API.CART, data);
      return response?.data?.token;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting all CARTS
export const getAllCart = createAsyncThunk(
  "get-all-cart",
  async (isSignIn, { rejectWithValue }) => {
    try {
      console.log(isSignIn, "isSignInCArt");

      if (isSignIn) {
        const response = await GET(API.GET_CART);
        return response;
      } else {
        const cartFromCookies = Cookies.get("Chefcut_Cart");

        if (cartFromCookies) {
          // Ensure the data is parsed correctly if it's a string
          let cartData = cartFromCookies;

          try {
            // Only parse if cartFromCookies is a string
            if (typeof cartFromCookies === "string") {
              cartData = JSON.parse(cartFromCookies);
            }
            const response = await POST(
              API.GET_ALL_CART_WITHOUT_LOGIN,
              cartData
            );

            if (response?.data?.dataToIndex?.length > 0) {
              const cartFromCookies = Cookies.get("Chefcut_Cart");
              const cartIndexesFromCookies = JSON.parse(
                cartFromCookies || "[]"
              );
              cartIndexesFromCookies.forEach((index) => {
                if (index >= 0 && index < cartData.length) {
                  cartData.splice(index, 1);
                }
              });
            }
            return response;
          } catch (error) {
            console.error("Error parsing cart data:", error);
            return [];
          }
        } else {
          return [];
        }
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Thunk for getting CART
export const getCart = createAsyncThunk(
  "get-cart",
  async ({ id, isSignIn }, { rejectWithValue }) => {
    try {
      const response = await GET(API.CART + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postToLoginCart = createAsyncThunk(
  "post-all-to-cart",
  async (_, { rejectWithValue }) => {
    try {
      let cartItems = [];
      const existingCart = Cookies.get("Chefcut_Cart");

      if (existingCart) {
        cartItems = JSON.parse(existingCart);
      }

      // Check if there are any items in the cart
      if (cartItems.length > 0) {
        // Post each cart item and wait for all responses
        const postResponses = await Promise.all(
          cartItems.map(async (value) => {
            const response = await POST(API.CART, value);
            return response?.data?.data;
          })
        );

        // Check if all responses were successful (status code 200)
        const allSuccess = postResponses.every(
          (response) => response?.status === 200
        );
        await Cookies.remove("Chefcut_Cart");
        // If all items were successfully posted, remove the cookies and return success
        if (allSuccess) {
          console.log("All items successfully posted to the server");
          await Cookies.remove("Chefcut_Cart");
          return { success: true };
        } else {
          // If any item failed, reject the thunk with a failure message
          console.log("Failed to post some items to the cart");
          return rejectWithValue("Failed to post some items to the cart");
        }
      } else {
        // If no items in the cart, just remove cookies and return success
        console.log("No items in the cart, removing session data");
        await Cookies.remove("Chefcut_Cart");
        return { success: true };
      }
    } catch (error) {
      console.error("Error in posting cart items:", error);
      return rejectWithValue(error.message);
    }
  }
);
// Thunk for Checking itme in  CART

// Thunk for posting CART

export const CheckProductInCart = createAsyncThunk(
  "check-cart",
  async ({ product_id, variant_id, isSignIn }, { rejectWithValue }) => {
    try {
      if (isSignIn) {
        const response = await GET(
          API.CHECk_ITEM_IN_CART +
            `?product_id=${product_id || ""}&variant_id=${variant_id || ""}`
        );
        return response?.data;
      } else {
        const cartFromCookies = Cookies.get("the_moon_cart");

        if (cartFromCookies) {
          const cartData = JSON.parse(cartFromCookies);
          const foundItem = cartData.find(
            (item) =>
              item.product_id === product_id && item.variant_id === variant_id
          );

          if (foundItem) {
            return { data: { success: true, cart_item: foundItem } };
          } else {
            return { data: { success: false, cart_item: null } };
          }
        } else {
          return { success: false, data: null };
        }
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for Change Quanitity

// Thunk for delete cart
export const deleteAllCart = createAsyncThunk(
  "delete-cart",
  async ({ id, isSignin, product_id, varient_id }, { rejectWithValue }) => {
    try {
      if (isSignin) {
        const response = await DELETE(API.CART + `/${id}`);
        return response?.data;
      } else {
        const cartData = Cookies.get("Chefcut_Cart");
        if (cartData) {
          let cart = JSON.parse(cartData);

          const updatedCart = cart.filter(
            (item) =>
              !(
                item.product_id === product_id && item.variant_id === varient_id
              )
          );

          Cookies.set("Chefcut_Cart", JSON.stringify(updatedCart), {
            expires: 7,
            path: "/",
          });

          return { success: true };
        } else {
          return { success: false, message: "No cart found in cookies" };
        }
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    allCarts: [],
    singleCart: {},
    checkItem: [],
    Cart: false,
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCart.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        // console.log(
        //   "getCart Response payload in fulfilled case:",
        //   action.payload
        // );
        state.allCarts = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(CheckProductInCart.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(CheckProductInCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        // console.log(
        //   "getCart Response payload in fulfilled case:",
        //   action.payload
        // );
        state.checkItem = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(CheckProductInCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getCart.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        // console.log(
        //   "getCart Response payload in fulfilled case:",
        //   action.payload
        // );
        state.singleCart = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(postCart.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(postCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        console.log("State after fulfilled", state);
      })
      .addCase(postCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(postCartQuantity.pending, (state) => {
        state.status = "loading";
        console.log("postCartQuantity State after pending", state);
      })
      .addCase(postCartQuantity.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          " postCartQuantity Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(postCartQuantity.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("postCartQuantity State after rejected", state);
      })

      .addCase(addToCard.pending, (state) => {
        state.status = "loading";
        console.log("postCartQuantity State after pending", state);
      })
      .addCase(addToCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          " postCartQuantity Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(addToCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("postCartQuantity State after rejected", state);
      })

      .addCase(deleteAllCart.pending, (state) => {
        state.status = "loading";
        console.log("postCartQuantity State after pending", state);
      })
      .addCase(deleteAllCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          " postCartQuantity Response payload in fulfilled case:",
          action.payload
        );
       
      })
      .addCase(deleteAllCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("postCartQuantity State after rejected", state);
      });
  },
});

export default cartSlice.reducer;
